import React, {useEffect, useState} from 'react';
import {useAuth} from "../../AuthContext";
import "./Peak.css";
import { Table } from "../../lv1ui";

    const PAGE_SIZE_OPTIONS = [10, 20, 30];
    const DEFAULT_PAGE_SIZE = PAGE_SIZE_OPTIONS[0]; // 👈 всегда берём первый
export function Peak() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const [campaignerId, setCampaignerId] = useState('');
    const [price, setPrice] = useState('0.00');
    const [campaignerImo, setCampaignerImo] = useState('');
    const [priceImo, setPriceImo] = useState('0.00');
    const [campaignerViber, setCampaignerViber] = useState('');
    const [priceViber, setPriceViber] = useState('0.00');
    const [campaignerTg, setCampaignerTg] = useState('');
    const [priceTg, setPriceTg] = useState('0.00');
    const [deliveryMode, setDeliveryMode] = useState('default'); // 'default' | 'file_save' | 'split'
    const [webhookUrl, setWebhookUrl] = useState('');
    const [webhookUrlTelegram, setWebhookUrlTelegram] = useState('');
    const [startBalance, setStartBalance] = useState('0.00');

    const [message, setMessage] = useState(null);

    const [users, setUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [userCampaigns, setUserCampaigns] = useState([]);
    const [selectedCampaignId, setSelectedCampaignId] = useState(null);
    const [campaignMessages, setCampaignMessages] = useState([]);

    const CHANNELS = ['whatsapp','telegram','viber','imo'];
    const [campaignerIdsByChannel, setCampaignerIdsByChannel] = useState({
        whatsapp: [], telegram: [], viber: [], imo: []
    });
    const [daysByChannel, setDaysByChannel] = useState({
        whatsapp: [], telegram: [], viber: [], imo: []
    });

    const [balanceMap, setBalanceMap] = useState({});

    const [showCreate, setShowCreate] = useState(false);

    const [fileDates, setFileDates] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedType, setSelectedType] = useState('filesave');
const [selectedChannel, setSelectedChannel] = useState('whatsapp');
    const [fileList, setFileList] = useState([]);

const [showAllMsgs, setShowAllMsgs] = useState(false);
const [allMessages, setAllMessages] = useState([]);
const [allPagination, setAllPagination] = useState({
  page: 1, pageSize: DEFAULT_PAGE_SIZE, total: 0, totalPages: 0,
});

const [cmFilters, setCmFilters] = useState({
  type: '', status: '', source: '', method: '',
  date_from: '', date_to: '', phone: ''
});

// для таблички All user messages
const [allFilters, setAllFilters] = useState({
  type: '', status: '', source: '', method: '',
  date_from: '', date_to: '', phone: ''
});

    // Глобальные "все сообщения"
    const [showGlobalMsgs, setShowGlobalMsgs] = useState(false);
    const [globalMessages, setGlobalMessages] = useState([]);
    const [gmPagination, setGmPagination] = useState({
        page: 1, pageSize: DEFAULT_PAGE_SIZE, total: 0, totalPages: 0,
    });

    const [gmFilters, setGmFilters] = useState({
        type:'', status:'', source:'', method:'', date_from:'', date_to:'', phone:''
    });

function getBucketFromFilename(name) {
    const m = name.match(/-(06|12|18|24)\.jsonl$/);
    return m ? m[1] : 'other';
}

function bucketLabel(bucket) {
    switch (bucket) {
        case '06': return '00:00–05:59';
        case '12': return '06:00–11:59';
        case '18': return '12:00–17:59';
        case '24': return '18:00–23:59';
        default: return 'Other';
    }
}

function groupFilesByBucket(files) {
    const groups = {
        '06': [],
        '12': [],
        '18': [],
        '24': [],
        'other': [],
    };

    for (const f of files) {
        const bucket = getBucketFromFilename(f.name);
        groups[bucket].push(f);
    }

    return groups;
}

async function downloadMergedBucket(bucket) {
    const url = `/api/admin/files/download-merged?date=${encodeURIComponent(selectedDate)}&type=${encodeURIComponent(selectedType)}&channel=${encodeURIComponent(selectedChannel)}&bucket=${encodeURIComponent(bucket)}`;
    const res = await fetchWithAuth(url);
    if (!res.ok) {
        alert('Merged download error');
        return;
    }
    const blob = await res.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `${selectedChannel}-${selectedType}-${selectedDate}-${bucket}.jsonl`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(a.href);
}

async function downloadMergedStatuses(bucket) {
    const url = `/api/admin/files/statuses-merged?date=${encodeURIComponent(selectedDate)}&type=${encodeURIComponent(selectedType)}&channel=${encodeURIComponent(selectedChannel)}&bucket=${encodeURIComponent(bucket)}`;
    const res = await fetchWithAuth(url);
    if (!res.ok) {
        alert('Merged statuses export error');
        return;
    }
    const blob = await res.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `stat-${selectedChannel}-${selectedType}-${selectedDate}-${bucket}.json`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(a.href);
}

async function downloadMergedXlsx(bucket, withHeader = false) {
    const url = `/api/admin/files/xlsx-merged?date=${encodeURIComponent(selectedDate)}&type=${encodeURIComponent(selectedType)}&channel=${encodeURIComponent(selectedChannel)}&bucket=${encodeURIComponent(bucket)}&withHeader=${withHeader ? '1' : '0'}`;
    const res = await fetchWithAuth(url);
    if (!res.ok) {
        alert('Merged XLSX download error');
        return;
    }
    const blob = await res.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `xlsx-${selectedChannel}-${selectedType}-${selectedDate}-${bucket}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(a.href);
}

function buildQuery(params) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k,v]) => {
    if (v !== undefined && v !== null && String(v).trim() !== '') usp.append(k, v);
  });
  return usp.toString();
}

    const fetchGlobalMessages = async (page = 1, limit = DEFAULT_PAGE_SIZE) => {
        const qs = buildQuery({ page, limit, ...gmFilters });
        const res = await fetchWithAuth(`/api/admin/all/messages?${qs}`);
        const data = await res.json();
        if (data.success) {
            setGlobalMessages(data.data);
            setGmPagination({
                page: data.page, pageSize: data.pageSize, total: data.total, totalPages: data.totalPages
            });
        }
    };

const fetchAllMessages = async (page=1, limit=DEFAULT_PAGE_SIZE) => {
  if (!selectedUserId) return;
  const qs = buildQuery({ page, limit, ...allFilters });
  const res = await fetchWithAuth(`/api/admin/users/${selectedUserId}/messages?${qs}`);
  const data = await res.json();
  if (data.success) {
    setAllMessages(data.data);
    setAllPagination({ page:data.page, pageSize:data.pageSize, total:data.total, totalPages:data.totalPages });
  }
};
    async function loadDates() {
        const res = await fetchWithAuth('/api/admin/files/dates');
        const data = await res.json();
        if (data.success) {
            setFileDates(data.dates);
            if (!selectedDate && data.dates.length) {
                setSelectedDate(data.dates[0]);
            }
        }
    }

async function loadFiles(date = selectedDate, type = selectedType, channel = selectedChannel) {
    if (!date) return;
    const res = await fetchWithAuth(
        `/api/admin/files/list?date=${encodeURIComponent(date)}&type=${encodeURIComponent(type)}&channel=${encodeURIComponent(channel)}`
    );
    const data = await res.json();
    if (data.success) setFileList(data.files);
}

    useEffect(() => {
        loadDates();
    }, []);

useEffect(() => {
    if (selectedDate) loadFiles(selectedDate, selectedType, selectedChannel);
}, [selectedDate, selectedType, selectedChannel]);

    async function downloadFile(name) {
        const url = `/api/admin/files/download?date=${encodeURIComponent(selectedDate)}&type=${encodeURIComponent(selectedType)}&name=${encodeURIComponent(name)}`;
        const res = await fetchWithAuth(url);
        if (!res.ok) {
            alert('Download error');
            return;
        }
        const blob = await res.blob();
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = name; // подсказка имени файла
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(a.href);
    }
async function downloadStatuses(name) {
  const url = `/api/admin/files/statuses?date=${encodeURIComponent(selectedDate)}&type=${encodeURIComponent(selectedType)}&name=${encodeURIComponent(name)}`;
  const res = await fetchWithAuth(url);
  if (!res.ok) {
    alert('Statuses export error');
    return;
  }
  const blob = await res.blob();
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  // имя будет выставлено Content-Disposition, но продублируем для совместимости
  const base = name.replace(/\.[^.]+$/, '');
  a.download = `stat-${base}.json`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
}

async function downloadXlsx(name, withHeader = true) {
  const url = `/api/admin/files/xlsx?date=${encodeURIComponent(selectedDate)}&type=${encodeURIComponent(selectedType)}&name=${encodeURIComponent(name)}&withHeader=${withHeader ? '1' : '0'}`;
  const res = await fetchWithAuth(url);
  if (!res.ok) {
    alert('XLSX download error');
    return;
  }
  const blob = await res.blob();
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `xlsx-${name.replace(/\.[^.]+$/,'')}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
}


    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        total: 0,
        totalPages: 0,
    });

    const { fetchWithAuth } = useAuth();

    const handleRegister = async () => {
        setMessage(null);
        if (!username || !password) {
            setMessage('Please fill in all fields');
            return;
        }

        const waOK = campaignerId && !isNaN(parseFloat(price));
        const imoOK = campaignerImo && !isNaN(parseFloat(priceImo));
        const viberOK = campaignerViber && !isNaN(parseFloat(priceViber));
        const tgOK = campaignerTg && !isNaN(parseFloat(priceTg));

        if (!waOK && !imoOK && !viberOK && !tgOK) {
            setMessage('Specify price and campaigner ID for at least one channel');
            return;
        }

        try {
            const res = await fetchWithAuth('/api/admin/register', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    username,
                    password,
                    price_wa: isNaN(parseFloat(price)) ? 0.00 : parseFloat(price),
                    price_imo: isNaN(parseFloat(priceImo)) ? 0.00 : parseFloat(priceImo),
                    price_viber: isNaN(parseFloat(priceViber)) ? 0.00 : parseFloat(priceViber),
                    price_telegram: isNaN(parseFloat(priceTg)) ? 0.00 : parseFloat(priceTg),
                    campaigner_id: campaignerId ? parseInt(campaignerId) : null,
                    campaigner_imo: campaignerImo ? parseInt(campaignerImo) : null,
                    campaigner_viber: campaignerViber ? parseInt(campaignerViber) : null,
                    campaigner_telegram: campaignerTg ? parseInt(campaignerTg) : null,

                    delivery_mode: deliveryMode,              // 'default' | 'file_save' | 'split'
                    webhook_url: webhookUrl || null,
                    webhook_url_telegram: webhookUrlTelegram || null,
                    balance: isNaN(parseFloat(startBalance)) ? 0.00 : parseFloat(startBalance)
                })
            });
            const data = await res.json();
            if (res.ok) {
                setMessage('✅ User successfully created');
                setUsername('');
                setPassword('');
                setCampaignerId('');
                setCampaignerImo('');
                setCampaignerViber('');
                setCampaignerTg('');
                setPrice('0.00');
                setPriceImo('0.00');
                setPriceViber('0.00');
                setPriceTg('0.00');
                setDeliveryMode('default');
                setWebhookUrl('');
                setWebhookUrlTelegram('');
                setStartBalance('0.00');
            } else {
                setMessage(`❌ Error: ${data.error}`);
            }
        } catch (err) {
            setMessage('❌ Network error');
        }
    };

    const fetchBalanceSnapshots = async () => {
        const res = await fetchWithAuth('/api/admin/balance-snapshots');
        const data = await res.json();
        if (data.success) {
            const map = {};
            data.data.forEach(r => {
                map[`${r.user_id}_${r.snapshot_date}`] = parseFloat(r.balance);
            });
            setBalanceMap(map);
        }
    };

    const fetchUsers = async () => {
        const res = await fetchWithAuth('/api/admin/users');
        const data = await res.json();
        if (data.success) setUsers(data.users);
    };

    const fetchUserCampaigns = async (userId) => {
        setSelectedUserId(userId);
        const res = await fetchWithAuth(`/api/admin/campaigns/${userId}`);
        const data = await res.json();
        if (data.success) setUserCampaigns(data.campaigns);
    };

const fetchCampaignMessages = async (campaignId, page=1, limit=DEFAULT_PAGE_SIZE) => {
  setSelectedCampaignId(campaignId);
  const qs = buildQuery({ page, limit, ...cmFilters });
  const res = await fetchWithAuth(`/api/admin/campaign/${campaignId}?${qs}`);
  const data = await res.json();
  if (data.success) {
    setCampaignMessages(data.data);
    setPagination({ page: data.page, pageSize: data.pageSize, total: data.total, totalPages: data.totalPages });
  }
};
    const fetchCampaignerIds = async (channel) => {
        const res = await fetchWithAuth(`/api/admin/campaignerIds?channel=${encodeURIComponent(channel)}`);
        const data = await res.json();

        if (data.success) {
            setCampaignerIdsByChannel(prev => ({ ...prev, [channel]: data.data }));
            const uniqDays = [...new Set(data.data.map(r => r.day))]
                .sort((a,b) => new Date(b) - new Date(a));
            setDaysByChannel(prev => ({ ...prev, [channel]: uniqDays }));
        }

    };


    useEffect(() => {
        fetchUsers();
        Promise.all(CHANNELS.map(ch => fetchCampaignerIds(ch)));
        fetchBalanceSnapshots();   // 👈 вот это
    }, []);

useEffect(() => {
  // при выборе нового пользователя скрываем таблицу "все сообщения" и сбрасываем данные
  setShowAllMsgs(false);
  setAllMessages([]);
  setAllPagination({ page: 1, pageSize: DEFAULT_PAGE_SIZE, total: 0, totalPages: 0 });
}, [selectedUserId]);

    // ==== таблица Users ====
    const userColumns = [
        { key: "id", label: "#" },
        { key: "username", label: "Username" },
        { key: "created_at", label: "Registration Date" },
        { key: "balance", label: "Balance" },
        { key: "campaigner_id", label: "CampaignerWA" },
        { key: "price_wa", label: "PriceWA" },
        { key: "campaigner_imo", label: "CampaignerImo" },
        { key: "price_imo", label: "PriceImo" },
        { key: "campaigner_viber", label: "CampaignerV" },
        { key: "price_viber", label: "PriceV" },
        { key: "campaigner_telegram", label: "CampaignerTG" },
        { key: "price_telegram", label: "PriceTG" },
        { key: "campaign_count", label: "Campaigns Amount" },
        { key: "last_campaign_date", label: "Last Campaign" },

        { key: "delivery_mode", label: "Mode" },
        { key: "webhook_url", label: "Webhook" },
        { key: "webhook_url_telegram", label: "Webhook TG" },
    ];
    const userRows = users.map((s) => ({
        ...s,
        created_at: new Date(s.created_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
        balance: `$${s.balance}`,
        webhook_url: s.webhook_url
            ? <span title={s.webhook_url}>
        {s.webhook_url.length > 30 ? s.webhook_url.slice(0, 30) + '…' : s.webhook_url}
      </span>
            : "",
        webhook_url_telegram: s.webhook_url_telegram
            ? <span title={s.webhook_url_telegram}>
      {s.webhook_url_telegram.length > 30 ? s.webhook_url_telegram.slice(0,30)+'…' : s.webhook_url_telegram}
    </span> : "",
        last_campaign_date: s.last_campaign_date
            ? new Date(s.last_campaign_date).toLocaleString('en-GB', { timeZone: 'UTC' })
            : "-",
        onClick: () => fetchUserCampaigns(s.id),
    }));

    // ==== таблица Campaigns ====
    const campaignColumns = [
        { key: "id", label: "ID" },
        { key: "name", label: "Name" },
        { key: "message", label: "Message" },
        { key: "created_at", label: "Created At" },
        { key: "channel", label: "Type" },
        { key: "total", label: "Total" },
        { key: "pending", label: "Pending" },
        { key: "sent", label: "Sent" },
        { key: "not_in_wa", label: "Not In WA" },
        { key: "delivered", label: "Delivered" },
        { key: "failed", label: "Failed" },
        { key: "undelivered", label: "Undelivered" },
    ];
    const campaignRows = userCampaigns.map((m) => ({
        ...m,
        message: m.message?.slice(0, 30) + "...",
        created_at: new Date(m.created_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
        onClick: () => fetchCampaignMessages(m.id),
    }));

    // ==== таблица Messages ====
    const msgColumns = [
        { key: "id", label: "ID" },
        { key: "dst_addr", label: "Phone Number" },
        { key: "field_1", label: "Field 1" },
        { key: "status", label: "Status" },
        { key: "price", label: "Price" },
        { key: "text", label: "Text" },
{ key: "source", label: "Source" },               // <—
        { key: "dispatch_method", label: "Delivery method" },
        { key: "created_at", label: "Created At" },
        { key: "status_updated_at", label: "Updated At" },
    ];
    const msgRows = campaignMessages.map((m) => ({
        ...m,
                dst_addr: m.dst_addr
            ? <span title={m.dst_addr}>{m.dst_addr}</span>
            : "",
        text: m.text
            ? <span title={m.text}>{`${m.text.slice(0, 30)}...`}</span>
            : "",
        created_at: new Date(m.created_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
        status_updated_at: new Date(m.status_updated_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
source: m.source || "",                           // <—
        dispatch_method: m.dispatch_method
    }));

const allMsgColumns = [
  { key: "id", label: "ID" },
  { key: "campaign_id", label: "Campaign" },
  { key: "channel", label: "Type" },
  { key: "dst_addr", label: "Phone" },
  { key: "status", label: "Status" },
  { key: "price", label: "Price" },
  { key: "text", label: "Text" },
  { key: "source", label: "Source" },
  { key: "dispatch_method", label: "Delivery method" },
  { key: "created_at", label: "Created" },
  { key: "status_updated_at", label: "Updated" },
];


const allMsgRows = allMessages.map(m => ({
  ...m,
  channel: (m.channel || '').toUpperCase(),
  dst_addr: m.dst_addr ? <span title={m.dst_addr}>{m.dst_addr}</span> : "",
  text: m.text ? <span title={m.text}>{`${m.text.slice(0,30)}...`}</span> : "",
  source: m.source || "",
  dispatch_method: m.dispatch_method,
  created_at: new Date(m.created_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
  status_updated_at: new Date(m.status_updated_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
}));

const globalMsgColumns = [
        { key: "id", label: "ID" },
        { key: "campaign_id", label: "Campaign" },
        { key: "channel", label: "Type" },
        { key: "dst_addr", label: "Phone" },
        { key: "status", label: "Status" },
        { key: "price", label: "Price" },
        { key: "text", label: "Text" },
        { key: "source", label: "Source" },
        { key: "dispatch_method", label: "Delivery method" },
        { key: "created_at", label: "Created" },
        { key: "status_updated_at", label: "Updated" },
    ];

    const globalMsgRows = globalMessages.map(m => ({
        ...m,
        channel: (m.channel || '').toUpperCase(),
        dst_addr: m.dst_addr ? <span title={m.dst_addr}>{m.dst_addr}</span> : "",
        text: m.text ? <span title={m.text}>{`${m.text.slice(0,30)}...`}</span> : "",
        source: m.source || "",
        dispatch_method: m.dispatch_method,
        created_at: new Date(m.created_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
        status_updated_at: new Date(m.status_updated_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
    }));


    function buildGrid(data) {
        // сгруппировать как прежде: campaigner_id -> {__users, day -> rec}
        return data.reduce((acc, r) => {
            const cid = r.campaigner_id;
            if (!acc[cid]) acc[cid] = { __users: [] };
            r.user_ids.forEach((uid, i) => {
                const uname = r.usernames[i];
                if (!acc[cid].__users.find(u => u.id === uid)) {
                    acc[cid].__users.push({ id: uid, username: uname });
                }
            });
            acc[cid][r.day] = r;
            return acc;
        }, {});
    }

    function makeGridColumns(days, title) {
        return [
            { key: "cid", label: `${title} — Campaigner / Users` },
            ...days.map(d => ({ key: d, label: new Date(d).toLocaleDateString() })),
        ];
    }

    function makeGridRows(gridObj, days, balanceMap) {
        return Object.entries(gridObj).map(([cid, dayMap]) => {
            const row = {
                cid: (
                    <>
                        <strong>{cid}</strong><br/>
                        {dayMap.__users.map(u => u.username).join(", ")}
                    </>
                )
            };
            days.forEach(d => {
                const rec = dayMap[d] || {
                    total:0, sent_cnt:0, sent_custom_cnt:0, not_in_wa_cnt:0,
                    delivered_cnt:0, failed_cnt:0, undelivered_cnt:0,
                    checkwa_cnt:0, expired_cnt:0
                };
                row[d] = (
                    <>
                        T:{rec.total}<br/>
                        s:{rec.sent_cnt}<br/>
                        s*:{rec.sent_custom_cnt}<br/>
                        n:{rec.not_in_wa_cnt}<br/>
                        d:{rec.delivered_cnt}<br/>
                        f:{rec.failed_cnt}<br/>
                        u:{rec.undelivered_cnt}<br/>
                        cwa:{rec.checkwa_cnt}<br/>
                        exp:{rec.expired_cnt}<br/>
                        {dayMap.__users.map(u => {
                            const bal = balanceMap[`${u.id}_${d}`];
                            return <div key={u.id}>{u.username}: {bal !== undefined ? bal : "n/a"}</div>;
                        })}
                    </>
                );
            });
            return row;
        });
    }
    return (
        <div className='peakPage'>
            <div className='peakContainer'>
                <div className="labelP" style={{display:'flex',alignItems:'center',gap:8}}>
                    <button
                        onClick={() => setShowCreate(s => !s)}
                        className="collapseBtn"
                        aria-expanded={showCreate}
                        title={showCreate ? 'Hide' : 'Show'}
                    >
                        <span className={`chevron`}>Create user</span><span className={`chevron ${showCreate ? 'open' : ''}`}>▼</span>
                    </button>
                </div>
                <div className={`togglePanel ${showCreate ? 'open' : ''}`}>
                    <div className="collapseInner">
                        <div className="labelP">Create user</div>
                        <input className="paymentWidgetAddNumber" placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Campaigner WA" value={campaignerId} onChange={e => setCampaignerId(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="WA price" value={price} onChange={e => setPrice(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Campaigner Imo" value={campaignerImo} onChange={e => setCampaignerImo(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Imo price" value={priceImo} onChange={e => setPriceImo(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Campaigner Viber" value={campaignerViber} onChange={e => setCampaignerViber(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Viber price" value={priceViber} onChange={e => setPriceViber(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Campaigner Tg" value={campaignerTg} onChange={e => setCampaignerTg(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Tg price" value={priceTg} onChange={e => setPriceTg(e.target.value)} /><br /><br />
                        <select
                            className="paymentWidgetAddNumber"
                            value={deliveryMode}
                            onChange={e => setDeliveryMode(e.target.value)}
                        >
                            <option value="default">delivery_mode: default</option>
                            <option value="file_save">delivery_mode: file_save</option>
                            <option value="split">delivery_mode: split</option>
                        </select>
                        <br /><br />
                        <input
                            className="paymentWidgetAddNumber"
                            placeholder="Webhook URL (optional)"
                            value={webhookUrl}
                            onChange={e => setWebhookUrl(e.target.value)}
                        />
                        <br /><br />
                        <input
                            className="paymentWidgetAddNumber"
                            placeholder="Webhook URL (Telegram, optional)"
                            value={webhookUrlTelegram}
                            onChange={e => setWebhookUrlTelegram(e.target.value)}
                        />
                        <br /><br />
                        <input
                            className="paymentWidgetAddNumber"
                            placeholder="Start balance"
                            value={startBalance}
                            onChange={e => setStartBalance(e.target.value)}
                        />
                        <br /><br />
                        <button onClick={handleRegister} className="addBalanceButton"><div className="addBalanceButtonText">Create user</div></button>
                        {message && <div style={{ marginTop: 10 }}>{message}</div>}
                    </div>
                </div>

                {/* таблицы */}

                {/* Кнопка показать/скрыть глобальную таблицу */}
                <div style={{ display:'flex', gap:12, alignItems:'center' }}>
                    <button
                        onClick={async () => {
                            const next = !showGlobalMsgs;
                            setShowGlobalMsgs(next);
                            if (next && globalMessages.length === 0) {
                                await fetchGlobalMessages(1, DEFAULT_PAGE_SIZE);
                            }
                        }}
                    >
                        {showGlobalMsgs ? 'Скрыть все сообщения (GLOBAL)' : 'Показать все сообщения (GLOBAL)'}
                    </button>
                </div>

                {showGlobalMsgs && (
                    <div style={{ marginTop: 24, width: "100%" }}>
                        <div className="labelP">All messages (GLOBAL)</div>

                        {/* Фильтры GLOBAL */}
                        <div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center', marginBottom:8}}>
                            <select value={gmFilters.type} onChange={e=>setGmFilters(f=>({...f, type:e.target.value}))}>
                                <option value="">Type: any</option>
                                <option value="whatsapp">whatsapp</option>
                                <option value="telegram">telegram</option>
                                <option value="viber">viber</option>
                                <option value="imo">imo</option>
                            </select>

                            <select value={gmFilters.status} onChange={e=>setGmFilters(f=>({...f, status:e.target.value}))}>
                                <option value="">Status: any</option>
                                <option value="checkwa">checkwa</option>
                                <option value="sent">sent</option>
                                <option value="delivered">delivered</option>
                                <option value="failed">failed</option>
                                <option value="undelivered">undelivered</option>
                                <option value="not_in_wa">not_in_wa</option>
                                <option value="expired">expired</option>
                            </select>

                            <select value={gmFilters.source} onChange={e=>setGmFilters(f=>({...f, source:e.target.value}))}>
                                <option value="">Source: any</option>
                                <option value="api">api</option>
                                <option value="lk">lk</option>
                                <option value="import">import</option>
                                <option value="bot">bot</option>
                                <option value="partner">partner</option>
                            </select>

                            <select value={gmFilters.method} onChange={e=>setGmFilters(f=>({...f, method:e.target.value}))}>
                                <option value="">Delivery: any</option>
                                <option value="api">api</option>
                                <option value="file_save">file_save</option>
                                <option value="split_uni">split_uni</option>
                                <option value="split_dup">split_dup</option>
                            </select>

                            <input type="date" value={gmFilters.date_from} onChange={e=>setGmFilters(f=>({...f, date_from:e.target.value}))}/>
                            <input type="date" value={gmFilters.date_to}   onChange={e=>setGmFilters(f=>({...f, date_to:e.target.value}))}/>
                            <input placeholder="Phone contains…" value={gmFilters.phone} onChange={e=>setGmFilters(f=>({...f, phone:e.target.value}))}/>

                            <button onClick={() => fetchGlobalMessages(1, gmPagination.pageSize)}>Apply</button>
                            <button onClick={() => {
                                setGmFilters({type:'', status:'', source:'', method:'', date_from:'', date_to:'', phone:''});
                                fetchGlobalMessages(1, gmPagination.pageSize);
                            }}>Reset</button>
                        </div>

                        <Table height="420px" columns={globalMsgColumns} rows={globalMsgRows} />

                        <div style={{ marginTop: 12, display: "flex", alignItems: "center", gap: 12 }}>
                            <button disabled={gmPagination.page === 1}
                                    onClick={() => fetchGlobalMessages(gmPagination.page - 1, gmPagination.pageSize)}>← Prev</button>
                            <span>Page {gmPagination.page} of {gmPagination.totalPages} ({gmPagination.total} messages)</span>
                            <button disabled={gmPagination.page === gmPagination.totalPages}
                                    onClick={() => fetchGlobalMessages(gmPagination.page + 1, gmPagination.pageSize)}>Next →</button>
                            <select value={gmPagination.pageSize}
                                    onChange={(e) => fetchGlobalMessages(1, Number(e.target.value))}>
                                {PAGE_SIZE_OPTIONS.map(size => <option key={size} value={size}>{size}</option>)}
                            </select>
                        </div>
                    </div>
                )}
                <div style={{ marginTop: 40, width: "100%" }}>
                    <div className="labelP">User list</div>
                    <Table height="300px" columns={userColumns} rows={userRows} />
                </div>
{selectedUserId && (
  <div style={{ display:'flex', gap:12, alignItems:'center', marginTop: 12 }}>
    <button
      onClick={async () => {
        const next = !showAllMsgs;
        setShowAllMsgs(next);
        if (next && allMessages.length === 0) {
          await fetchAllMessages(1, DEFAULT_PAGE_SIZE);
        }
      }}
    >
      {showAllMsgs ? 'Скрыть все сообщения пользователя' : 'Показать все сообщения пользователя'}
    </button>
  </div>
)}
{showAllMsgs && selectedUserId && (
  <div style={{ marginTop: 24, width: "100%" }}>
    <div className="labelP">All messages of user #{selectedUserId}</div>
{/* Фильтры для All user messages */}
<div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center', marginBottom:8}}>
  <select value={allFilters.type} onChange={e=>setAllFilters(f=>({...f, type:e.target.value}))}>
    <option value="">Type: any</option>
    <option value="whatsapp">whatsapp</option>
    <option value="telegram">telegram</option>
    <option value="viber">viber</option>
    <option value="imo">imo</option>
  </select>

  <select value={allFilters.status} onChange={e=>setAllFilters(f=>({...f, status:e.target.value}))}>
    <option value="">Status: any</option>
    <option value="checkwa">checkwa</option>
    <option value="sent">sent</option>
    <option value="delivered">delivered</option>
    <option value="failed">failed</option>
    <option value="undelivered">undelivered</option>
    <option value="not_in_wa">not_in_wa</option>
    <option value="expired">expired</option>
  </select>

  <select value={allFilters.source} onChange={e=>setAllFilters(f=>({...f, source:e.target.value}))}>
    <option value="">Source: any</option>
    <option value="api">api</option>
    <option value="lk">lk</option>
    <option value="import">import</option>
    <option value="bot">bot</option>
    <option value="partner">partner</option>
  </select>

  <select value={allFilters.method} onChange={e=>setAllFilters(f=>({...f, method:e.target.value}))}>
    <option value="">Delivery: any</option>
    <option value="api">api</option>
    <option value="file_save">file_save</option>
    <option value="split_uni">split_uni</option>
    <option value="split_dup">split_dup</option>
  </select>

  <input
    type="date"
    value={allFilters.date_from}
    onChange={e=>setAllFilters(f=>({...f, date_from:e.target.value}))}
  />
  <input
    type="date"
    value={allFilters.date_to}
    onChange={e=>setAllFilters(f=>({...f, date_to:e.target.value}))}
  />

  <input
    placeholder="Phone contains…"
    value={allFilters.phone}
    onChange={e=>setAllFilters(f=>({...f, phone:e.target.value}))}
  />

<button onClick={() => fetchAllMessages(1, allPagination.pageSize)}>
  Apply
</button>

<button
  onClick={() => {
    setAllFilters({ type:'', status:'', source:'', method:'', date_from:'', date_to:'', phone:'' });
    fetchAllMessages(1, allPagination.pageSize);
  }}
>
  Reset
</button>
</div>
    <Table height="420px" columns={allMsgColumns} rows={allMsgRows} />
    <div style={{ marginTop: 12, display: "flex", alignItems: "center", gap: 12 }}>
      <button disabled={allPagination.page === 1}
              onClick={() => fetchAllMessages(allPagination.page - 1, allPagination.pageSize)}>← Prev</button>
      <span>Page {allPagination.page} of {allPagination.totalPages} ({allPagination.total} messages)</span>
      <button disabled={allPagination.page === allPagination.totalPages}
              onClick={() => fetchAllMessages(allPagination.page + 1, allPagination.pageSize)}>Next →</button>
      <select value={allPagination.pageSize}
              onChange={(e) => fetchAllMessages(1, Number(e.target.value))}>
        {PAGE_SIZE_OPTIONS.map(size => <option key={size} value={size}>{size}</option>)}
      </select>
    </div>
  </div>
)}
                {selectedUserId && userCampaigns.length > 0 && (
                    <div style={{ marginTop: 40, width: "100%" }}>
                        <div className="labelP">User campaigns #{selectedUserId}</div>
                        <Table height="400px" columns={campaignColumns} rows={campaignRows} />
                    </div>
                )}

                {selectedCampaignId && campaignMessages.length > 0 && (
                    <div style={{ marginTop: 40, width: "100%" }}>
                        <div className="labelP">
                            Campaign messages #{selectedCampaignId}
                        </div>
<div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center', marginBottom:8}}>
  <select value={cmFilters.type} onChange={e=>setCmFilters(f=>({...f, type:e.target.value}))}>
    <option value="">Type: any</option>
    <option value="whatsapp">whatsapp</option>
    <option value="telegram">telegram</option>
    <option value="viber">viber</option>
    <option value="imo">imo</option>
  </select>
  <select value={cmFilters.status} onChange={e=>setCmFilters(f=>({...f, status:e.target.value}))}>
    <option value="">Status: any</option>
    <option value="checkwa">checkwa</option>
    <option value="sent">sent</option>
    <option value="delivered">delivered</option>
    <option value="failed">failed</option>
    <option value="undelivered">undelivered</option>
    <option value="not_in_wa">not_in_wa</option>
    <option value="expired">expired</option>
  </select>
  <select value={cmFilters.source} onChange={e=>setCmFilters(f=>({...f, source:e.target.value}))}>
    <option value="">Source: any</option>
    <option value="api">api</option>
    <option value="lk">lk</option>
    <option value="import">import</option>
    <option value="bot">bot</option>
    <option value="partner">partner</option>
  </select>
  <select value={cmFilters.method} onChange={e=>setCmFilters(f=>({...f, method:e.target.value}))}>
    <option value="">Delivery: any</option>
    <option value="api">api</option>
    <option value="file_save">file_save</option>
    <option value="split_uni">split_uni</option>
    <option value="split_dup">split_dup</option>
  </select>
  <input type="date" value={cmFilters.date_from} onChange={e=>setCmFilters(f=>({...f, date_from:e.target.value}))}/>
  <input type="date" value={cmFilters.date_to} onChange={e=>setCmFilters(f=>({...f, date_to:e.target.value}))}/>
  <input placeholder="Phone contains…" value={cmFilters.phone} onChange={e=>setCmFilters(f=>({...f, phone:e.target.value}))}/>
<button onClick={() => fetchCampaignMessages(selectedCampaignId, 1, pagination.pageSize)}>
  Apply
</button>

<button
  onClick={() => {
    setCmFilters({ type:'', status:'', source:'', method:'', date_from:'', date_to:'', phone:'' });
    fetchCampaignMessages(selectedCampaignId, 1, pagination.pageSize);
  }}
>
  Reset
</button></div>
                        <Table height="400px" columns={msgColumns} rows={msgRows} />

                        {/* пагинация */}
                        <div style={{
                            marginTop: 12,
                            display: "flex",
                            alignItems: "center",
                            gap: 12
                        }}>
                            <button
                                disabled={pagination.page === 1}
                                onClick={() =>
                                    fetchCampaignMessages(
                                        selectedCampaignId,
                                        pagination.page - 1,
                                        pagination.pageSize
                                    )
                                }
                            >
                                ← Prev
                            </button>

                            <span>
                Page {pagination.page} of {pagination.totalPages} ({pagination.total} messages)
            </span>

                            <button
                                disabled={pagination.page === pagination.totalPages}
                                onClick={() =>
                                    fetchCampaignMessages(
                                        selectedCampaignId,
                                        pagination.page + 1,
                                        pagination.pageSize
                                    )
                                }
                            >
                                Next →
                            </button>

                            <select
                                value={pagination.pageSize}
                                onChange={(e) =>
                                    fetchCampaignMessages(selectedCampaignId, 1, Number(e.target.value))
                                }
                            >
                                {PAGE_SIZE_OPTIONS.map(size => (
                                    <option key={size} value={size}>{size}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}

                {CHANNELS.map(ch => {
                    const data = campaignerIdsByChannel[ch] || [];
                    const days = daysByChannel[ch] || [];
                    const gridObj = buildGrid(data);
                    const columns = makeGridColumns(days, ch.toUpperCase());
                    const rows = makeGridRows(gridObj, days, balanceMap);
                    return (
                        <div key={ch} style={{ marginTop: 40, width: "100%" }}>
                            <div className="labelP">{ch.toUpperCase()} Campaigners</div>
                            <Table height="350px" columns={columns} rows={rows} />
                        </div>
                    );
                })}
<div style={{ marginTop: 40, width: "100%" }}>
                    <div className="labelP">Saved files</div>

<div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 12, flexWrap: 'wrap' }}>
    <select
        className="paymentWidgetAddNumber"
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
    >
        {fileDates.map(d => <option key={d} value={d}>{d}</option>)}
    </select>

    <select
        className="paymentWidgetAddNumber"
        value={selectedType}
        onChange={(e) => setSelectedType(e.target.value)}
    >
        <option value="filesave">filesave</option>
        <option value="split">split</option>
    </select>

    <select
        className="paymentWidgetAddNumber"
        value={selectedChannel}
        onChange={(e) => setSelectedChannel(e.target.value)}
    >
        <option value="whatsapp">whatsapp</option>
        <option value="telegram">telegram</option>
        <option value="viber">viber</option>
        <option value="imo">imo</option>
    </select>

    <button onClick={() => loadFiles(selectedDate, selectedType, selectedChannel)}>Refresh</button>
</div>

{(() => {
    const grouped = groupFilesByBucket(fileList);
    const orderedBuckets = ['06', '12', '18', '24'];

    return orderedBuckets.map(bucket => {
        const files = grouped[bucket] || [];
        if (!files.length) return null;

        return (
            <div key={bucket} style={{ marginBottom: 28 }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 10,
                    gap: 12,
                    flexWrap: 'wrap'
                }}>
                    <div className="labelP" style={{ margin: 0 }}>
                        {bucketLabel(bucket)} — {files.length} file(s)
                    </div>

                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        <button onClick={() => downloadMergedBucket(bucket)}>
                            Download all
                        </button>
                        <button onClick={() => downloadMergedStatuses(bucket)}>
                            Statuses all
                        </button>
                        <button onClick={() => downloadMergedXlsx(bucket, false)}>
                            XLSX all
                        </button>
                    </div>
                </div>

                <Table
                    height="220px"
                    columns={[
                        { key: 'name', label: 'File' },
                        { key: 'size', label: 'Size (bytes)' },
                        { key: 'mtime', label: 'Modified' },
                        { key: 'actions', label: '' },
                    ]}
                    rows={files.map(f => ({
                        name: f.name,
                        size: f.size,
                        mtime: new Date(f.mtime).toLocaleString('en-GB', { timeZone: 'UTC' }),
                        actions: (
                            <div style={{ display: 'flex', gap: 8 }}>
                                <button onClick={() => downloadFile(f.name)}>Download</button>
                                <button onClick={() => downloadStatuses(f.name)}>Statuses</button>
                                <button onClick={() => downloadXlsx(f.name, false)}>XLSX</button>
                            </div>
                        ),
                    }))}
                />
            </div>
        );
    });
})()}
                    
                </div>
            </div>
        </div>
    );
};
